import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'

@Component({
    selector: 'time-picker',
    templateUrl: './time-picker.component.html',
    styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {

    @Input() control: UntypedFormControl;
    @Input() diff: number = 1; // difference in minutes
    mask = [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/];
    pipe = createAutoCorrectedDatePipe('HH:MM');
    
    ngOnInit() {
        let value: string = this.control.value;
        if (value && value.length > 5) {
            this.control.setValue(value.slice(0, 5))
        }
    }

    onKeyDown(e) {
        if (e.which === 38) {
            this.onUpdateClick(1);
            e.preventDefault();
        } else if (e.which === 40) {
            this.onUpdateClick(-1);
            e.preventDefault();
        }
    }

    onUpdateClick(direction: number) {
        let value: string = this.control.value;
        if (!value || value === '') value = '00:00';
        let time: Date = new Date(`01 Jan 1970 ${value}:00`);

        if (direction > 0) {
            // up
            time = new Date(time.getTime() + (this.diff * 60000));
        } else {
            // down
            time = new Date(time.getTime() - (this.diff * 60000));
        }

        value = time.toTimeString().slice(0, 5);
        this.control.setValue(value);
    }
}
